import { useHasFeature } from "@/hooks/useHasFeature";

import { FeatureProps } from "./type";
import { Upsale } from "./upsale";

export const Feature = ({
  required,
  children,
  upsale,
  asChild,
  fallback = null,
}: FeatureProps) => {
  const allow = useHasFeature(required);

  return allow ? (
    <>{children}</>
  ) : upsale ? (
    <Upsale asChild={asChild} required={required}>
      {children}
    </Upsale>
  ) : fallback ? (
    fallback
  ) : null;
};
